export { default as usePageTracking } from './usePageTracking';
export { loadAnalyticsWithConsent, getAnalytics } from './loadAnalyticsWithConsent';
export type { SegmentAnalytics } from './loadAnalyticsWithConsent';
export { default as useLoadAnalytics } from './useLoadAnalytics';
import * as WebTracking from './web/segment';
export { WebTracking };
export * from './segmentTransformers';
export * as commonTracking from './common-tracking';

export * as bookingTracking from '~/integrations/segment/bookingTracking';
export * as userTracking from '~/integrations/segment/userTracking';
export * as catalogTracking from '~/integrations/segment/catalogTracking';
